var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.375C5.57812 0.375 0.375 5.57812 0.375 12C0.375 18.4219 5.57812 23.625 12 23.625C18.4219 23.625 23.625 18.4219 23.625 12C23.625 5.57812 18.4219 0.375 12 0.375ZM16.3355 15.0469L15.398 16.2188C15.3364 16.2957 15.2604 16.3597 15.1741 16.4072C15.0878 16.4548 14.993 16.4848 14.8951 16.4957C14.7972 16.5066 14.6982 16.4981 14.6036 16.4707C14.5089 16.4432 14.4207 16.3975 14.3438 16.3359L11.2031 14.0053C10.9837 13.8296 10.8066 13.6068 10.6848 13.3534C10.5631 13.1 10.5 12.8225 10.5 12.5414V5.25C10.5 5.05109 10.579 4.86032 10.7197 4.71967C10.8603 4.57902 11.0511 4.5 11.25 4.5H12.75C12.9489 4.5 13.1397 4.57902 13.2803 4.71967C13.421 4.86032 13.5 5.05109 13.5 5.25V12L16.2188 13.9922C16.2957 14.0537 16.3598 14.1299 16.4073 14.2162C16.4548 14.3025 16.4848 14.3974 16.4957 14.4953C16.5065 14.5933 16.4979 14.6924 16.4705 14.7871C16.443 14.8817 16.3971 14.97 16.3355 15.0469Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaClock);
export default __webpack_public_path__ + "static/media/FaClock.693702371eef59705738986b3f5be908.svg";
export { ForwardRef as ReactComponent };